import { apiClient } from './client';

export interface LeaderboardXPEntry {
  rank: number;
  userId: string;
  username: string;
  xp: number;
  level: number;
}

export interface LeaderboardChallengeEntry {
  rank: number;
  userId: string;
  username: string;
  score: number;
  time: number;
  completedAt?: string;
}

export interface LeaderboardRoomEntry {
  rank: number;
  userId: string;
  username: string;
  time: number;
  puzzlesCompleted: number;
  completedAt?: string;
}

export const leaderboardApi = {
  async getXPLeaderboard(limit?: number): Promise<LeaderboardXPEntry[]> {
    const params = limit ? `?limit=${limit}` : '';
    return apiClient.get(`/leaderboard/xp${params}`);
  },

  async getChallengeLeaderboard(
    challengeId: string,
    limit?: number
  ): Promise<LeaderboardChallengeEntry[]> {
    const params = limit ? `?limit=${limit}` : '';
    return apiClient.get(`/leaderboard/challenges/${challengeId}${params}`);
  },

  async getRoomLeaderboard(
    roomId: string,
    limit?: number
  ): Promise<LeaderboardRoomEntry[]> {
    const params = limit ? `?limit=${limit}` : '';
    return apiClient.get(`/leaderboard/escape-rooms/${roomId}${params}`);
  },
};
